import { render, staticRenderFns } from "./DoATest.vue?vue&type=template&id=457a61be&"
import script from "./DoATest.vue?vue&type=script&lang=js&"
export * from "./DoATest.vue?vue&type=script&lang=js&"
import style0 from "./DoATest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports